import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import BackButton from '@/views/checkout/components/back-button';
import { i18n } from '@/core/i18n';
import { Tracker } from '@/views/checkout/utilities';
import { CheckoutService } from '@/services';

@Component({
    data() {
        return {
            languages: null
        };
    },
    components: {
        BackButton
    }
})
export default class MerchantDetails extends mixins(i18n.Mixins.Culture) {
    @Prop()
    tradeName: string;

    @Prop()
    statementDescriptor: string;

    @Prop()
    urlCancel: string;

    @Prop()
    logo: string;

    @Prop()
    image: string;

    @Prop()
    orderCode: string;

    languages: Array<any>;

    async created() {
        await this.importLanguage();

        this.languages = this.getSortedLanguages();
    }

    async cancelPaymentOrder() {
        const { success, data } = await CheckoutService.cancelPaymentOrder(+this.orderCode);

        if (success) {
            Tracker.trackPaymentCancelled();
            window.location.href = this.urlCancel;
        } else {
            this.$emit('error');
        }
    }
}
